import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import Header from 'apps/components/header/header';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { IssueCard } from 'legacyComponents/cards/types/issue';
import { SectionBanner, Paragraph, Box } from 'components';
import { BANNER_ACTIONS } from 'constants/analytics';
import { analytics } from 'core/analytics';

import CommunityTasksManager from 'apps/home/community/tasks/appManager';

@withNamespaces()
@inject('routerStore')
@observer
export default class CommunityTasks extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new CommunityTasksManager(null, this.props);
  }

  render() {
    const { t } = this.props;
    const connection = this.appManager.issuesConn;
    const issues = connection.arrayApp;
    return (
      <>
        <Header />
        <MainWrapper>
          <SectionBanner
            bannerId='tasks-banner-id'
            imageSrc='/assets/banners/003.svg'
            title='Create or help with public Tasks.'
            buttonText='Learn more'
            linkName='https://help.wikifactory.com/en/articles/4618408-track-progress-with-issues'
            paddingTop='xlarge'
            paddingBottom='xxlarge'
            eventCallback={() =>
              analytics.sendEvent(BANNER_ACTIONS.COMMUNITY_TASKS)
            }
          >
            <Box>
              <Paragraph>
                Tasks in public Projects are open to the Community, so{' '}
                <strong>anyone can collaborate and feedback</strong> from there.
              </Paragraph>
              <Paragraph>
                <strong>Move your ideas forward</strong> with the wisdom of the
                crowd.{' '}
              </Paragraph>
              <Paragraph>
                Or <strong>apply your skills and expertise</strong> in existing
                tasks to get involved.
              </Paragraph>
            </Box>
          </SectionBanner>
          <CardSection
            invisible={this.appManager.loading}
            title={t('Open Tasks')}
            subTitle=' '
            isOwnProfile={false}
            ownerName=''
            cardApp={issues}
            CardComponent={IssueCard}
            noDataCardType='issue'
          />
        </MainWrapper>
      </>
    );
  }
}

CommunityTasks.propTypes = {
  t: PropTypes.func,
};
